import React from 'react';
import { motion } from 'framer-motion';
import Image from '../../../components/AppImage';

const TrustBannerSection = ({ currentLanguage }) => {
  const content = {
    EN: {
      poweredBy: "Powered by"
    },
    FR: {
      poweredBy: "Propulsé par"
    }
  };

  const text = content?.[currentLanguage] || content?.EN;

  return (
    <section className="py-12 bg-white border-y border-gray-200">
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
          className="flex items-center justify-center space-x-8"
        >
          <div className="text-gray-600 font-medium text-lg">
            {text?.poweredBy}
          </div>
          
          {/* PSPXpress Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-primary rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-sm">PSP</span>
            </div>
            <span className="text-2xl font-bold text-primary">PSPXpress</span>
          </div>
          
          {/* Separator */}
          <div className="w-1 h-8 bg-gray-300 rounded-full"></div>
          
          {/* Equifax Logo */}
          <div className="flex items-center space-x-2">
            <div className="w-10 h-10 bg-blue-900 rounded-lg flex items-center justify-center">
              <span className="text-white font-bold text-xs">EQ</span>
            </div>
            <span className="text-2xl font-bold text-blue-900">Equifax<sup className="text-sm">®</sup></span>
          </div>
          
          {/* Separator */}
          <div className="w-1 h-8 bg-gray-300 rounded-full"></div>
          
          {/* Mastercard Logo - Updated with provided asset */}
          <div className="flex items-center space-x-3">
            <div className="w-12 h-8 overflow-hidden rounded-md">
              <Image
                src="/assets/images/image-1757454378302.png"
                alt="Mastercard"
                className="w-full h-full object-contain"
              />
            </div>
            <span className="text-2xl font-bold text-gray-800">Mastercard<sup className="text-sm">®</sup></span>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default TrustBannerSection;